<script>
    export let pratos_principais;
</script>

<style>
    .pratos-principais {
        padding-top: 100px;
        padding-bottom: 50px;
        font-family: "Poppins", sans-serif;
    }

    .title h1 {
        font-weight: 600;
        padding-bottom: 40px;
    }

    @media (max-width: 991.98px) {
        .title h1 {
            font-size: 30px !important;
            font-weight: 600;
            padding-bottom: 40px;
        }
    }

    .single-feature {
        font-size: 14px;
        padding-top: 30px;
        padding-left: 60px;
    }

    .single-feature h4 {
        padding-top: 10px;
        padding-bottom: 15px;
        font-size: 16px;
        font-weight: 600;
    }

    .single-feature b {
        color: #f42f2c;
        font-weight: 600;
    }
</style>

<main>
    <section id="pratos-principais" class="pratos-principais">
        <div class="title text-center">
            <h1>Prato Principal</h1>
        </div>
        <div class="feature-section">
            <div class="row">
                {#each pratos_principais as valor}
                    <div class="single-feature col-lg-4 col-md-6">
                        <img src={valor.img} alt="" />
                        <h4>{valor.categoria}</h4>
                        {#each valor.pratos as prato}
                            <b>{prato.nome}</b>
                            {#each prato.tamanhos as tamanho}
                                <br />{tamanho.nome}: R$
                                {tamanho.valor}
                            {/each}
                            <br /><br />
                        {/each}
                    </div>
                {/each}
            </div>
        </div>
    </section>
</main>
